import { useEffect, useSyncExternalStore } from "react";
import { memberRouter } from "../../app/runtime";
import type { Transaction, TransactionGroup } from "../shared/types";
import { navigate } from "../shared/ui";

export const transactionGroups = [
  { value: "ALL", label: "전체" },
  { value: "REVIEW", label: "심사" },
  { value: "PAYMENT_PENDING", label: "결제대기" },
  { value: "IN_PROGRESS", label: "진행중" },
  { value: "COMPLETED", label: "완료" },
  { value: "CLOSED", label: "종료" },
] as const satisfies readonly { value: TransactionGroup; label: string }[];

export function readTransactionGroup(search = window.location.search): TransactionGroup {
  const value = new URLSearchParams(search).get("group");
  return transactionGroups.find(group => group.value === value)?.value ?? "ALL";
}

/** Display classification only; never infer financial permissions from a group. */
export function serverTransactionGroup(transaction: Transaction): Exclude<TransactionGroup, "ALL"> {
  const match = transactionGroups.find(group => group.value !== "ALL" && group.value === transaction.group);
  return match ? match.value as Exclude<TransactionGroup, "ALL"> : "IN_PROGRESS";
}

export function transactionPath(path: string, group = readTransactionGroup()): string {
  const url = new URL(path, window.location.origin);
  url.searchParams.set("group", group);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function useTransactionGroup(): TransactionGroup {
  const search = useSyncExternalStore(memberRouter.subscribe, () => window.location.search, () => "");
  const group = readTransactionGroup(search);
  useEffect(() => {
    const value = new URLSearchParams(search).get("group");
    if (value !== null && value !== group) {
      navigate(transactionPath(`${window.location.pathname}${search}${window.location.hash}`, "ALL"), true);
    }
  }, [search, group]);
  return group;
}
